import React from 'react';
import Error from './Error';

export default function AccessDenied({ title = "Access Denied", message = "You do not have sufficient privileges to access this resource.", ...props }) {
    return (<Error title={title} message={message}>{ props.children }</Error>);
}